<script>
  import { createEventDispatcher, onMount } from 'svelte';
  import Dialog from '../Dialog';

  const dispatch = createEventDispatcher();

  let dialog;

  export let size = undefined;
  export let position = undefined;
  export let testid = undefined;
  export let allowClose = true;

  let dismissed = false;
  function cancelIfNecessary() {
    if (!dismissed) {
      dispatch('cancel');
    }
  }

  // Corresponds to the `return` event, but return is a keyword
  export function next(value) {
    dismissed = true;
    dispatch('return', value);
    dialog.dismiss();
  }

  export function cancel() {
    dismissed = true;
    dispatch('cancel');
    dialog.dismiss();
  }

  onMount(() => dialog.show());
</script>

<Dialog {size} {position} {testid} {allowClose} bind:this={dialog} on:dismiss={cancelIfNecessary}>
  <slot slot='title' name='title' />
  <slot {next} {cancel} />
  <slot slot='action' name='action' {next} {cancel} />
</Dialog>
